import { TranslationLabels } from "translations/TranslationLabels";

export enum AgendaItemStatusEnum {
  Unknown = 0,
  Default = 1,
  Approved = 2,
  Published = 3,
  Finalized = 4,
  Archived = 5,
  Deleted = 6,
}

/**
 * Gets the localized label for an AgendaItemStatusEnum value.
 */
export function getAgendaItemStatusLabel(status: AgendaItemStatusEnum, i18n: TranslationLabels): string {
  switch (status) {
    case AgendaItemStatusEnum.Unknown:
      return i18n.AgendaItemStatus_Unknown;
    case AgendaItemStatusEnum.Default:
      return i18n.AgendaItemStatus_Default;
    case AgendaItemStatusEnum.Approved:
      return i18n.AgendaItemStatus_Approved;
    case AgendaItemStatusEnum.Published:
      return i18n.AgendaItemStatus_Published;
    case AgendaItemStatusEnum.Finalized:
      return i18n.AgendaItemStatus_Finalized;
    case AgendaItemStatusEnum.Archived:
      return i18n.AgendaItemStatus_Archived;
    case AgendaItemStatusEnum.Deleted:
      return i18n.AgendaItemStatus_Deleted;
    default:
      return `Unknown AgendaItemStatus: ${status}`;
  }
}
